'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = error;

var _actions = require('../actions');

function error() {
  var currentError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case _actions.COMMIT_EDITING_NAVIGATION_ITEM_FAILURE:
    case _actions.DELETE_NAVIGATION_ITEM_FAILURE:
    case _actions.FETCH_NAVIGATION_ITEMS_FAILURE:
    case _actions.FETCH_PAGES_FAILURE:
    case _actions.SORT_NAVIGATION_ITEMS_FAILURE:
      return action.error.message;

    case _actions.COMMIT_EDITING_NAVIGATION_ITEM_SUCCESS:
    case _actions.DELETE_NAVIGATION_ITEM_SUCCESS:
    case _actions.SORT_NAVIGATION_ITEMS_SUCCESS:
      return null;

    default:
      return currentError;
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/reducers/error.js
// module id = 423
// module chunks = 0